"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDonorFeesPayPal = void 0;
const enums_1 = require("../types/enums");
const constants_1 = require("../constants");
const calculatePayPalFee_1 = require("./payPalFees/calculatePayPalFee");
const calculateDonorFeesPayPal = ({ amount = 0, coverFees = false, nonprofitCountryCode = 'US', feeCoveredBy = enums_1.FeeCoveredBy.User, isSandbox, applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_EMPLOYEE, applicationFeeAmountCap, isRecurring, donationProvider, }) => {
    if (donationProvider !== enums_1.DonationProvider.PayPal) {
        throw Error(`donationProvider must be ${enums_1.DonationProvider.PayPal}`);
    }
    if (!nonprofitCountryCode) {
        throw new Error('nonprofitCountryCode is required when donating with PayPal');
    }
    const areFeesCoveredByDeed = feeCoveredBy === enums_1.FeeCoveredBy.Deed;
    return (0, calculatePayPalFee_1.calculatePayPalFee)({
        amount,
        nonprofitCountryCode,
        applicationFee: areFeesCoveredByDeed ? 0 : applicationFeeSetting,
        applicationFeeAmountCap,
        coverFees,
        isRecurring,
        donationProvider,
        isSandbox,
    });
};
exports.calculateDonorFeesPayPal = calculateDonorFeesPayPal;
//# sourceMappingURL=calculateDonorFeesPayPal.js.map